import { isPresent } from '../../utils/isPresent';
import { React, Fragment, useState, useRef } from "react";
import ResponsiveMasonry from "react-masonry-css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";
import { Menu, Dialog, Transition } from '@headlessui/react';
import NewSingleCard from "./NewSingleCard";
import "../SingleBucket";
import axios from "axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import "moment";
// import {ReactComponent as CalenderIcon} from "../../assets/icons/calendarIcon.svg";

import { useOutletContext } from "react-router-dom";
import CreateBucket from "../CreateBucket";

import DeleteIcon from '../../assets/icons/delete.svg';
import LightDelete from "../../assets/icons/Grey_Delete.svg";



import ThreeDots from '../../assets/icons/threeDots.svg';
import Arrow from '../../assets/icons/arrow.svg';
import { CardSkeletonGrid } from "./CardSkeleton";

import { ReactComponent as MySVG } from "../../assets/icons/7601886_top_arrow-update.svg";
import ScrollToTop from "react-scroll-to-top";
import { toastify } from '../../components/Toast';
import { ToastContainer } from 'react-toastify';
import MoveModal from "./includes/MoveModal";
import BlackDismiss from '../../assets/icons/dismissButton.svg'
import ShareCard from "./shareCard";
import 'react-toastify/dist/ReactToastify.css';

// Keep the starred-card layout aligned with the All Cards view.
const cardGridBreakpoints = {
  default: 5,
  1535: 4,
  1279: 3,
  1023: 2,
  767: 1,
};

function StarredCard() {
  const [isLoadings, setIsLoadings] = useState(false);
  useState([]);
  const [cardList, setCardList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [popup, setPopup] = useState(false);
  const [bucketCreated, setBucketCreated] = useState(false);
  const [cardCreated, setCardCreated] = useState(false);
  const [bucketOperation, ] = useState('Add');
  const [selectedItems, setSelectedItems] = useState([]);
  useState(false);
  let [isOpenss, setIsOpens] = useState(false);
  useOutletContext();
  const [lastList, setLastList] = useState(false);
  const [openMove, setOpenMove] = useState(false);
  const [moveModal, setMoveModal] = useState(false)
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [buckets, setBuckets] = useState([]);
  const [totalCards, setTotalCards] = useState(0);
  const [BucketSharePopup, setBucketSharePopup] = useState(false)
  const [shareBucketId, setShareBucketId] = useState('')
  const [appTheme, setAppTheme] = useState("")
  const bucketId = useParams();

  // Platform and Format filter states
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [selectedFormats, setSelectedFormats] = useState([]);
  const [showPlatformFilter, setShowPlatformFilter] = useState(false);
  const [showFormatFilter, setShowFormatFilter] = useState(false);

  // Platform and Format filter options
  const platformOptions = [
    { name: "Instagram", value: "instagram" },
    { name: "Facebook", value: "facebook" },
    { name: "TikTok", value: "TikTok" },
    { name: "Twitter", value: "twitter" },
    { name: "YouTube", value: "youtube" }
  ];

  const formatOptions = [
    { name: "Video", value: "Video" },
    { name: "Image", value: "Image" },
    { name: "Carousel", value: "Carousel" }
  ];




  function closeCardModal() {
    // setSelectedItems([]);
    setIsOpens(false);
  }
  useEffect(() => {
    const handleStorageChange = () => {
      const theme = localStorage.getItem("theme");
      setAppTheme(theme);
    };

    window.addEventListener('storage', handleStorageChange);

    // Force a re-render when localStorage changes
    setAppTheme(localStorage.getItem("theme"));

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  useEffect(() => {
    // Function to fetch data from the API and update the state
    const token = localStorage.getItem('token');
    const fetchBuckets = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}buckets/user-buckets`, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }); // Replace this with the actual API endpoint
        setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if (token) {
      fetchBuckets();
    }
  }, []);
  const filterDropDown = [
    { name: 'Created Date', href: '#' },
    { name: 'Recent Activity', href: '#' },
    { name: 'Ascending Order', href: '#' },
    { name: 'Descending Order', href: '#' },
    // { name: 'Manual', href: '#' },
  ]

  let cardFilterv = '';
  if (!localStorage.getItem("cardFilter")) {
    localStorage.setItem('cardFilter', 'Created_Date');
    cardFilterv = 'Created_Date';
  } else {
    cardFilterv = localStorage.getItem("cardFilter");
  }
  const [cardFilterDefault, setCardFilterDefault] = useState(cardFilterv);
  const loadingPageRef = useRef(false);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    // api url
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      loadingPageRef.current = true;
      setIsLoadings(true)
      axios.post(`${process.env.REACT_APP_API}cards/cards-with-stars`, {
        filterValue: cardFilterDefault
        , "page": currPage, "limit": 8,
        "platform": selectedPlatforms,
        "format": selectedFormats
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
      })
        .then(function (response) {
          if (!active) return;
          setIsLoading(false);
          if (!response.data.data.cardsList.length) {
            setLastList(true);
            setIsLoadings(false);
            return;
          }
          setPrevPage(currPage);
          // setUserList([...userList, ...response.data.data]);
          setCardList(current => [...current, ...response.data.data.cardsList]);
          setTotalCards(response.data.data.totalCards);
          setIsLoadings(false);
          // reorder(response.data.data.slice(0,response.data.data.length),4);
          // setBucketList(response.data.data.bucketList);
          // setTotalBuckets(response.data.data.total);

        })
        .catch(function (error) {
          if (active && !controller.signal.aborted) console.error(error);
        }).finally(() => {
          if (active) { loadingPageRef.current = false; setIsLoadings(false); }
        });
    }
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      if (!loadingPageRef.current && !lastList && parseInt(scrollTop) + parseInt(clientHeight) === parseInt(scrollHeight)) {
        setCurrPage(current => current + 1);
      }
    };

    if (!lastList && prevPage !== currPage) {
      fetchData();
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      active = false;
      controller.abort();
      window.removeEventListener("scroll", handleScroll);
    };
  }, [bucketCreated, cardCreated, currPage, lastList, prevPage, selectedPlatforms,
    selectedFormats, cardFilterDefault])



  // const [filtersText, setFiltersText] = useState(filterDropDown[0].name);
  const [filtersText, setFiltersText] = useState((cardFilterv === 'Created_Date') ? filterDropDown[0].name : (
    cardFilterv === 'Descending_Order' ? filterDropDown[3].name : (
      cardFilterv === 'Ascending_Order' ? filterDropDown[2].name : (
        cardFilterv === 'Recent_Activity' ? filterDropDown[1].name : ""
      )
    )
  ));
  const closeSharePop = () => {
    setBucketSharePopup(false)
  }
  const handleSharePop = (id) => {
    setShareBucketId(id)
    setBucketSharePopup(true)
  }
  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== value)
      );
    }
  };

  const deleteCard = async () => {
    setIsOpens(true);
  };

  const handleDeleteCard = async () => {
    setIsLoading(true);
    const token = localStorage.getItem('token');
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API}cards/delete`,
        {
          data: { deletedIds: selectedItems },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      toastify("success", response.data.message);
      setSelectedItems([]);
      closeCardModal();
      cardUpdate();
    } catch (error) {
      console.error(error);
      closeCardModal();
      setIsLoading(false);
      toastify("error", error.response.data.message);
    }
  }
  const MoveCard = async () => {
    setMoveModal(true)
    setOpenMove(true);
  };

  const closeMove = () => {
    // setIsBucketOpen(false);
    setSelectedItems([])
    setMoveModal(false)
    setOpenMove(false);
    // setselectedBucketId("");
    // setSearchBucket("");
  };
  const handleFilterText = (text) => {
    // setFiltersText(text);
    setIsLoading(true);
    setFiltersText(text);
    const filterValues = (text === 'Created Date') ? "Created_Date" : (
      text === 'Descending Order' ? "Descending_Order" : (
        text === 'Ascending Order' ? "Ascending_Order" : (
          text === 'Recent Activity' ? "Recent_Activity" : ""
        )
      )
    );
    localStorage.setItem('cardFilter', filterValues);
    setCardFilterDefault(filterValues);
    setCurrPage(1);
    setPrevPage(0);
    setLastList(false);
    setCardList([]);
  }




  // Platform filter handlers
  const handlePlatformChange = (platformValue) => {
    setSelectedPlatforms(prev => {
      if (prev.includes(platformValue)) {
        return prev.filter(p => p !== platformValue);
      } else {
        return [...prev, platformValue];
      }
    });
    cardUpdate();
  };

  const handleSelectAllPlatforms = () => {
    setSelectedPlatforms(platformOptions.map(p => p.value));
    cardUpdate();
  };

  const handleUnselectAllPlatforms = () => {
    setSelectedPlatforms([]);
    cardUpdate();
  };

  const handlePlatformFilterClick = (e) => {
    e.preventDefault();
    setShowPlatformFilter(!showPlatformFilter);
    setShowFormatFilter(false); // Close other filter
  };

  // Format filter handlers
  const handleFormatChange = (formatValue) => {
    setSelectedFormats(prev => {
      if (prev.includes(formatValue)) {
        return prev.filter(f => f !== formatValue);
      } else {
        return [...prev, formatValue];
      }
    });
    cardUpdate();
  };

  const handleSelectAllFormats = () => {
    setSelectedFormats(formatOptions.map(f => f.value));
    cardUpdate();
  };

  const handleUnselectAllFormats = () => {
    setSelectedFormats([]);
    cardUpdate();
  };

  const handleFormatFilterClick = (e) => {
    e.preventDefault();
    setShowFormatFilter(!showFormatFilter);
    setShowPlatformFilter(false); // Close other filter
  };

  // Close filters when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.platform-filter') && !event.target.closest('.format-filter')) {
        setShowPlatformFilter(false);
        setShowFormatFilter(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const bucketNav = [
    { icon: faTrash, name: "Select All", href: "#" },
    { icon: faTrash, name: "Unselect All", href: "#" },
    // {icon:faPencil, name: 'Edit Name', href: '#' },
    // {icon:faNoteSticky, name: 'Create New Card', href: '#' },
    // {icon:faTrash, name: 'Delete', href: '#' },
    // {icon:faFolder, name: 'Customize New Card', href: '#' },
  ]

  const handleAllCardClick = (text) => {
    if (text === "Select All") {
      var checkboxes = document.querySelectorAll(
        '.cardheight-content input[type="checkbox"]'
      );
      var checkedValues = []; // Array to store the values of checked checkboxes

      checkboxes.forEach(function (checkbox) {
        if (!checkbox.checked) {
          var checked = true; // Replace with your desired checked state
          checkbox.checked = checked;
          if (checkbox.checked) {
            checkedValues.push(checkbox.value);
            setSelectedItems((prevSelectedItems) => [
              ...prevSelectedItems,
              checkbox.value,
            ]);
          }
        } else {
          checked = false; // Replace with your desired checked state
          checkbox.checked = checked;
          setSelectedItems([]);
        }
      });
    } else if (text === "Unselect All") {
      checkboxes = document.querySelectorAll(
        '.cardheight-content input[type="checkbox"]'
      );
      checkedValues = []; // Array to store the values of checked checkboxes

      checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          var checked = false; // Replace with your desired checked state
          checkbox.checked = checked;
          setSelectedItems([]);
        }
      });
    }
  };








  function cardUpdate() {
    // setBucketCreated(true);
    setLastList(false);
    setCurrPage(1);
    setPrevPage(0);
    setCardList([]);
    setCardCreated(!cardCreated);
  }

  const handleStarredChange = (cardId, starred) => {
    if (starred) {
      setCardList((cards) =>
        cards.map((card) =>
          card._id === cardId ? { ...card, starred } : card
        )
      );
      return;
    }

    setCardList((cards) => cards.filter((card) => card._id !== cardId));
    setSelectedItems((items) => items.filter((id) => id !== cardId));
    setTotalCards((count) => Math.max(0, count - 1));
  };

  function bucketUpdate() {
    // setBucketCreated(true);
    setBucketCreated(!bucketCreated);
  }



  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  return (
    <>
      {
        isLoading ? (
          <div className='App-loading'>
            <div className='App-logo' title='Zimzee' />
          </div>
        )
          :
          (
            <div className="subBuckets-whole listingCards responsive-page responsive-page--starred-cards">
              <div className="cards">

                <div className="starred-cards-toolbar cards-filter cardsspacing-content flex justify-between">
                  <div className="starred-cards-toolbar__primary flex items-center">
                    <div className="card-count flex items-center">
                      <h4 className="cardssubBuckets-content">Cards</h4><span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">{totalCards}</span>
                    </div>
                    {BucketSharePopup &&
                      <div className="filesuploadpopup relative !z-[999]" style={{ height: "100%" }} onClick={closeSharePop}>
                        <div className="subinviteupload-section" onClick={(e) => e.stopPropagation()}>
                          <div className="teaminvitesection flex">
                            <div className="teammembers-content">Share</div>
                            <div className="dismissSubfiles-content" onClick={closeSharePop}><img src={BlackDismiss} alt="dismissButton" /></div>
                          </div>
                          <ShareCard shareBucketId={shareBucketId} closeSharePop={closeSharePop} cardsRefresh={cardUpdate} />
                        </div>
                      </div>

                    }
                    <Menu as="div" className="relative px-2">
                      <Menu.Button
                        className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 "
                      >
                        {/* <FontAwesomeIcon className="text-lg text-[#707070]" icon={faEllipsisVertical} /> */}
                        <img src={ThreeDots} alt="threeDots" />
                      </Menu.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {bucketNav.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <a
                                  href={item.href}
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block py-2 px-4 text-sm text-gray-700'
                                  )}
                                  onClick={() => {
                                    handleAllCardClick(item.name);
                                  }}
                                >
                                  <span className="pr-2"><FontAwesomeIcon className="text-[#797979]" icon={item.icon} /></span>
                                  <span className="text-black">{item.name}</span>
                                </a>
                              )}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                    {selectedItems.length > 0 ?
                      <img
                        src={appTheme === "light" ? DeleteIcon : LightDelete}
                        alt="deleteIcon"
                        className="px-3"
                        onClick={() => deleteCard()}
                      />
                      :
                      <img
                        src={appTheme === "light" ? LightDelete : DeleteIcon}
                        alt="deleteIcon"
                        className="px-3"
                      // onClick={() => deleteCard()}
                      />
                    }
                    <Transition appear show={isOpenss} as={Fragment}>
                      <Dialog as="div" className="relative z-10" onClose={closeCardModal}>
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <div className="fixed inset-0 bg-black bg-opacity-25" />
                        </Transition.Child>

                        <div className="fixed inset-0 overflow-y-auto">
                          <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0 scale-95"
                              enterTo="opacity-100 scale-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100 scale-100"
                              leaveTo="opacity-0 scale-95"
                            >
                              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                                <Dialog.Title
                                  as="h3"
                                  className="text-lg font-medium leading-6 text-gray-900"
                                >
                                  Delete
                                </Dialog.Title>
                                <div className="mt-2">
                                  <p className="text-sm text-gray-500">
                                    Are you sure you want to delete?
                                  </p>
                                </div>

                                <div className="mt-4">
                                  <button style={{ background: '#FF6600', width: "80px", color: "#fff", padding: "10px", borderRadius: "50px" }}
                                    type="button"
                                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                    onClick={() => handleDeleteCard()}
                                  >
                                    Yes
                                  </button>
                                  <button style={{ background: '#000', width: "80px", color: "#fff", padding: "10px", borderRadius: "50px" }}
                                    type="button"
                                    className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                    onClick={closeCardModal}
                                  >
                                    No
                                  </button>
                                </div>
                              </Dialog.Panel>
                            </Transition.Child>
                          </div>
                        </div>
                      </Dialog>
                    </Transition>
                    {/* <FontAwesomeIcon className="transform rotate-45 px-3" icon={faArrowUp } /> */}
                    <img src={Arrow} alt="arrow" className="px-3" onClick={MoveCard} />
                  </div>
                  <div className="starred-cards-toolbar__filters filterHolder flex items-center justify-end">
                    {/* <div className="filter display-content"> 
                            <a className="viewGrid" href={getUrl('list')}>                            
                             <img className="mt-1 listcard-imgcontent" src={ListView} alt="listView" />
                            </a>
                            <a className="viewGrid" href={getUrl('grid')}>                            
                             <img className="mt-1 compact-imgcontent" src={compactCardIcon} style={{color:'#000000'}} alt="compactIcon" />
                            </a>
                        </div> */}
                    {/* Platform Filter */}
                    <div className="platform-filter relative flex-shrink-0 mr-3">
                      <button
                        onClick={handlePlatformFilterClick}
                        className="flex rounded-full focus:outline-none"
                      >
                        <span data-former-link=""

                          className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                        >
                          <strong className="createdtext-content pr-4">
                            Platform ({selectedPlatforms.length})
                          </strong>
                          <FontAwesomeIcon
                            style={{ fontSize: "12px", color: "#707070" }}
                            icon={faChevronDown}
                          />
                        </span>
                      </button>
                      {showPlatformFilter && (
                        <div className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div className="px-4 py-2 border-b border-gray-200 hidden">
                            <div className="flex justify-between items-center">
                              <span className="text-sm font-medium text-gray-700">Platforms</span>
                              <div className="flex space-x-2">
                                <button
                                  onClick={handleSelectAllPlatforms}
                                  className="text-xs text-blue-600 hover:text-blue-800"
                                >
                                  All
                                </button>
                                <button
                                  onClick={handleUnselectAllPlatforms}
                                  className="text-xs text-red-600 hover:text-red-800"
                                >
                                  None
                                </button>
                              </div>
                            </div>
                          </div>
                          {platformOptions.map((platform) => (
                            <div key={platform.value}>
                              <button
                                onClick={() => handlePlatformChange(platform.value)}
                                className={classNames(
                                  "w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                                )}
                              >
                                <span>{platform.name}</span>
                                {selectedPlatforms.includes(platform.value) && (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    className="text-blue-600 text-sm"
                                  />
                                )}
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Format Filter */}
                    <div className="format-filter relative flex-shrink-0 mr-3">
                      <button
                        onClick={handleFormatFilterClick}
                        className="flex rounded-full focus:outline-none"
                      >
                        <span data-former-link=""

                          className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                        >
                          <strong className="createdtext-content pr-4">
                            Format ({selectedFormats.length})
                          </strong>
                          <FontAwesomeIcon
                            style={{ fontSize: "12px", color: "#707070" }}
                            icon={faChevronDown}
                          />
                        </span>
                      </button>
                      {showFormatFilter && (
                        <div className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div className="px-4 py-2 border-b border-gray-200 hidden">
                            <div className="flex justify-between items-center">
                              <span className="text-sm font-medium text-gray-700">Formats</span>
                              <div className="flex space-x-2">
                                <button
                                  onClick={handleSelectAllFormats}
                                  className="text-xs text-blue-600 hover:text-blue-800"
                                >
                                  All
                                </button>
                                <button
                                  onClick={handleUnselectAllFormats}
                                  className="text-xs text-red-600 hover:text-red-800"
                                >
                                  None
                                </button>
                              </div>
                            </div>
                          </div>
                          {formatOptions.map((format) => (
                            <div key={format.value}>
                              <button
                                onClick={() => handleFormatChange(format.value)}
                                className={classNames(
                                  "w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                                )}
                              >
                                <span>{format.name}</span>
                                {selectedFormats.includes(format.value) && (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    className="text-blue-600 text-sm"
                                  />
                                )}
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <span className="sorttext-content mx-3 dark:text-[#acacac]">Sort By</span>
                    <Menu as="div" className="relative flex-shrink-0">
                      <div>
                        <Menu.Button className="flex rounded-full focus:outline-none ">
                          <span data-former-link=""

                            className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                          >
                            <strong className="createdtext-content pr-4">{filtersText}</strong>
                            <FontAwesomeIcon style={{ fontSize: '12px', color: '#707070' }} icon={faChevronDown} />
                          </span>
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">

                          {filterDropDown.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (

                                <a
                                  onClick={() => { handleFilterText(item.name) }}
                                  href={item.href}
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block py-2 px-4 text-sm text-gray-700'
                                  )}
                                >
                                  {item.name}
                                </a>
                              )}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
              </div>
              {/* Single Card */}
              <div className="mansorydesktop-section">
                <ResponsiveMasonry
                  breakpointCols={cardGridBreakpoints}
                  className="card-masonry flex -ml-4 w-auto"
                  columnClassName="card-masonry__column pl-4 bg-clip-padding"
                >
                  {cardList?.map((card) => {
                    const sharedWithObjects = card?.shared
                      ? card.shared
                        .filter(shares => isPresent(shares.sharedWith))
                        .map(shares => shares.sharedWith)
                      : [];
                    return (
                      <div key={card._id} className="w-full inline-block break-inside-avoid mb-[-3px]" style={{ contain: 'inline-size' }}>
                        <NewSingleCard
                          selectedItems={selectedItems}
                          handleSharePop={handleSharePop}
                          starred={card.starred}
                          buckets={buckets}
                          cardUpdate={cardUpdate}
                          cardId={card._id}
                          cardType={card.cardType}
                          sharedBy={[]}
                          sharedUsers={sharedWithObjects}
                          sharedLength={card.shared?.length || 0}
                          title={card.title}
                          content={card.content}
                          note={card.note}
                          tags={card.tags}
                          postDetail={card.postDetail || ""}
                          updated={card.updatedAt}
                          handleCheckboxChange={handleCheckboxChange}
                          adData={card.adData}
                          aiData={card.content?.extractedData || null}
                          onStarredChange={handleStarredChange}
                        />
                      </div>
                    );
                  })}
                </ResponsiveMasonry>
                {isLoadings && <CardSkeletonGrid />}
              </div>
            </div>
          )
      }
      {popup === true ? <CreateBucket bucketUpdate={bucketUpdate} bucketOperation={bucketOperation} parent={bucketId.id} setPopup={setPopup} /> : null}
      {moveModal ? <MoveModal openMove={openMove} closeModal={closeMove} selectedItems={selectedItems} cardUpdate={cardUpdate} buckets={buckets} /> : null}

      <ToastContainer />
      <ScrollToTop smooth color="#fff" component={<MySVG />} />
    </>
  )
}

export default StarredCard;
